import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Chrome } from '@/components/layout/Chrome';
import { api } from '@/lib/api';

interface Item {
  _id: string;
  status: string;
  personal?: { forename?: string; surname?: string; email?: string };
  agency?: { name?: string };
  occupation?: { sector?: string; role?: string; cis?: boolean };
  submittedAt: string;
}

interface ListResponse {
  items: Item[];
  total: number;
  page: number;
  pageSize: number;
}

export const AdminListPage = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['registrations'],
    queryFn: async () => (await api.get<ListResponse>('/registrations')).data,
  });

  return (
    <Chrome>
      <div className="min-h-[60vh] bg-ink-50 px-6 py-9">
        <div className="mx-auto max-w-6xl rounded-lg bg-white p-6 shadow-card">
          <h1 className="text-lg font-black uppercase tracking-widest text-navy">
            Submissions {data ? `(${data.total})` : ''}
          </h1>
          {isLoading && <p className="mt-4 text-sm text-ink-500">Loading…</p>}
          {error && <p className="mt-4 text-sm text-red-600">Failed to load.</p>}
          {data && data.items.length === 0 && (
            <p className="mt-4 text-sm text-ink-500">No submissions yet.</p>
          )}
          {data && data.items.length > 0 && (
            <table className="mt-4 w-full text-left text-sm">
              <thead className="text-[11px] uppercase tracking-wider text-ink-500">
                <tr>
                  <th className="py-2">Name</th>
                  <th>Email</th>
                  <th>Agency</th>
                  <th>Sector / Role</th>
                  <th>CIS</th>
                  <th>Submitted</th>
                  <th />
                </tr>
              </thead>
              <tbody className="divide-y divide-ink-50 text-ink-700">
                {data.items.map((i) => (
                  <tr key={i._id}>
                    <td className="py-3">
                      {i.personal?.forename} {i.personal?.surname}
                    </td>
                    <td>{i.personal?.email}</td>
                    <td>{i.agency?.name}</td>
                    <td>
                      {i.occupation?.sector} / {i.occupation?.role}
                    </td>
                    <td>{i.occupation?.cis ? 'Yes' : 'No'}</td>
                    <td>{new Date(i.submittedAt).toLocaleString()}</td>
                    <td>
                      <Link className="btn-edit" to={`/admin/submissions/${i._id}`}>
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Chrome>
  );
};
